







































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';
import { ItoggleEvent } from '@/components/Checkbox/CheckBoxTypes';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ToggleBox from '@/componentsV2/molecules/ToggleBox/ToggleBox.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton,
    ToggleBox,
    Checkbox
  }
})
export default class ActiveSellCoins extends Vue {
  @Prop() onConfirm!: any;
  @Prop() onClose!: any;

  loading: boolean = false;
  initial: boolean = true;
  sellCoinsStatus: boolean = false;

  handleClose() {
    eventBus.$emit('closeModal');
    this.onClose();
  }

  async handleConfirm() {
    this.loading = true;
    await this.onConfirm(this.sellCoinsStatus);
    this.loading = false;
    this.handleClose();
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }

  get tTogglePrefix() {
    return 'onboarding.coin.sellCoins';
  }

  onToggleSellCoins(event: ItoggleEvent) {
    this.sellCoinsStatus = event.state;
    this.initial = false;
  }
}
